import './style';
import App from './app';

export default App;
